import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Card, CardContent } from '@/components/ui/card';
import { Sparkles } from 'lucide-react';

export const STAGE_TONE = {
  1: { text: 'text-amber-700', bg: 'bg-amber-50', border: 'border-amber-300', bar: 'bg-amber-400' },
  2: { text: 'text-sky-700', bg: 'bg-sky-50', border: 'border-sky-300', bar: 'bg-sky-400' },
  3: { text: 'text-violet-700', bg: 'bg-violet-50', border: 'border-violet-300', bar: 'bg-violet-400' },
  4: { text: 'text-emerald-700', bg: 'bg-emerald-50', border: 'border-emerald-300', bar: 'bg-emerald-500' },
};

export const CompanionPanelNotice = ({ placement = 'page' }) => {
  if (placement === 'portal') {
    return (
      <div
        className="mx-auto mb-4 max-w-xl rounded-full border border-cyan-300/40 bg-cyan-500/10 px-5 py-2 text-center text-sm text-cyan-100 backdrop-blur"
        data-testid="companion-panel-notice-portal"
      >
        Your consciousness companion panel is now open
      </div>
    );
  }

  return (
    <Card className="border-2 border-cyan-400 bg-gradient-to-r from-cyan-50 to-violet-50" data-testid="companion-panel-notice">
      <CardContent className="p-6 flex items-start gap-4">
        <Sparkles className="w-6 h-6 text-cyan-600 shrink-0 mt-0.5" />
        <div>
          <h3 className="text-base md:text-lg font-semibold text-gray-900">
            Your consciousness companion panel is now open
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            Every assessment you complete from here on adds to it — your stages, your dimensions and
            the way your development is moving over time.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default CompanionPanelNotice;

/** Self-fetching wrapper — renders nothing until the member's first assessment is scored. */
export const CompanionPanelBanner = ({ placement = 'page' }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    axios.get(`${API}/assessments/my/summary`)
      .then((res) => setOpen(!!res.data.companion_panel_open))
      .catch(() => setOpen(false));
  }, []);

  if (!open) return null;
  return <CompanionPanelNotice placement={placement} />;
};
